const OTP_LENGTH = 6

// Prefers the first 6-digit run so a stray number in the message ("Order 99, code 123456")
// cannot corrupt the code; falls back to stripping non-digits ("123-456").
export function extractOtpDigits(raw: string): string {
	const run = /\d{6}/.exec(raw)?.[0]
	if (run) return run
	return raw.replace(/\D/g, '').slice(0, OTP_LENGTH)
}
